import { LogIn, Volume2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function HeroSection() {
  return (
    <section
      className="relative overflow-hidden bg-peninsula-graphite peninsula-texture-dark"
      aria-labelledby="hero-heading"
    >
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-6 sm:py-32 lg:px-8 lg:py-40">
        <div className="mx-auto max-w-3xl text-center">
          <div className="mb-6 inline-flex items-center gap-2 rounded-sm border border-white/20 bg-white/5 px-4 py-1.5 text-sm text-white/80">
            <Volume2 className="size-4 text-peninsula-magma" aria-hidden="true" />
            Servicio de vocalización
          </div>

          <h1
            id="hero-heading"
            className="text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl"
          >
            Haz que tu{' '}
            <span className="text-peninsula-magma">web hable</span>
          </h1>

          <p className="mt-6 text-lg text-white/70 leading-relaxed sm:text-xl">
            Convierte cualquier portal web en una experiencia accesible con
            vocalización en tiempo real. Cumplimiento WCAG 2.2 AA garantizado,
            integración en una sola línea de código.
          </p>

          <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
            <Button asChild size="xl" variant="secondary" className="font-semibold">
              <a href="/admin/login">
                <LogIn className="size-5" aria-hidden="true" />
                Acceder al panel
              </a>
            </Button>
            <Button asChild variant="outline" size="xl" className="bg-transparent border-white/30 text-white hover:bg-white/10 hover:text-white">
              <a href="#features">
                Descubrir funcionalidades
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
